import "./index.css";
import { render } from "solid-js/web";
import App from "./App";
import { initSentry } from "./sentry";

initSentry();

render(() => <App />, document.getElementById("root") as HTMLElement);
